import React, { Component } from 'react';
import { Button, LoadingIndicator, TextField } from '../../../components';
import MenuItem from '@material-ui/core/MenuItem';
import SearchIcon from '@material-ui/icons/Search';
import theme from '../../../app.theme';
import SearchResults from '../';
import queryString from 'query-string';
import ENV from '../../../../run-config';
import { ThemeColors } from '../../../theme';
// import SearchIcon from '@material-ui/icons/Search'

class Search extends Component {

  constructor(props) {
    super(props);

    this.state = {
      searchTerm: queryString.parse(this.props.location.search).searchTerm || '',
    };

    this.onChange = this.onChange.bind(this);
    this.primaryColor = theme.palette.primary1Color;
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.updateCurrendWidth = this.updateCurrendWidth.bind(this);
  }

  componentDidMount() {
    this.updateCurrendWidth();
    window.addEventListener('resize', this.updateCurrendWidth);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateCurrendWidth);
  }

  onSearch(searchTerm) {
    if (searchTerm) {
      this.props.onSearch(searchTerm.replace(/^\s+/, ""));
    }
  }

  onChange(event) {
    this.setState({ searchTerm: event.target.value });
  }

  updateCurrendWidth() {
    this.setState({ currentWindowWidth: window.innerWidth });
  }

  handleKeyPress(e) {
    if (e.key === 'Enter') {
      this.onSearch(this.state.searchTerm);
    }
  }

  renderButton() {
    const searchButton = {
      float: 'right',
    };

    return this.state.currentWindowWidth > 700
      ? (
        <Button
          labelStyle={{ color: '#FFFFFF' }}
          onClick={() => this.onSearch(this.state.searchTerm)}
          style={{ ...searchButton, ...{ backgroundColor: ThemeColors.searchButtonColor || ThemeColors.accent1Color } }}
        >
          <SearchIcon style={{ color: ThemeColors.searchButtonIconColor || ThemeColors.primary1Color }} />
        </Button>
      )
      : null;
  }

  render() {
    if (!ENV.searchFeature ||
      (this.props.config && this.props.config.supportsSearch && this.props.config.supportsSearch === 'false')) {
      return null;
    }

    const searchbar = {
      margin: '10px 10px 0px 10px',
      borderWidth: 1,
      display: 'flex',
      justifyContent: 'space-between',
      borderStyle: 'solid',
      borderColor: '#eee',
    };

    return (
      <div style={searchbar}>
        <TextField
          disableUnderline
          style={{ marginTop: 0, marginLeft: 5 }}
          placeholder={'Suche'}
          formControlStyle={{ width: '100%' }}
          defaultValue={this.state.searchTerm}
          value={this.state.searchTerm}
          onChange={this.onChange}
          onKeyPress={this.handleKeyPress}
        />
        {this.renderButton()}
      </div>
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/app/main/search/search-bar/search-bar.js